import { ExternalAdditiveRequestDTO } from 'models/ExternalAdditiveRequestDTO'
import { StepsFormProps } from '../interface'
import { mountContract } from './mountContract'

export const mountExternalAdditive = (
    data: StepsFormProps
): ExternalAdditiveRequestDTO => {
    const contractPayload = mountContract(data) as any

    const {
        dataAditivo,
        numAditivoContrato,
        numAditivoContratoOrigem,
        numeroRegistroContrato,
        tipoAditivo,
        ...contrato
    } = contractPayload

    const registroContrato = data.contract.numeroRegistroContrato?.trim()

    return {
        ...(registroContrato
            ? { numeroRegistroContrato: registroContrato }
            : {}),
        numeroAditivo: Number(data.contract.numAditivoContratoOrigem),
        contrato
    }
}
